import CentredSpinner, {
    ICentredSpinnerComponentProps,
} from './CentredSpinner';

export interface ICentredSpinnerProps extends ICentredSpinnerComponentProps {}
export default CentredSpinner;
